/**
 * Hero tokens SSOT — espejo TS de `src/app/hero-tokens.css`.
 *
 * El CSS es la verdad runtime para estilos; importa estos valores solo cuando
 * JS los necesita (canvas, SVG inline, gradientes construidos en código).
 * Mantener sincronizado a mano con hero-tokens.css.
 *
 * --accent = app chrome monocromo, --hero-* = marketing. Nunca renombrar --accent.
 */
export const HERO_TOKENS = {
  blue: "#4b73ff",
  magenta: "#ff66f4",
  red: "#ff0105",
  orange: "#fe7b02",
  focus: "rgba(168, 85, 247, 0.45)",
  /** focusRing: sólido #a855f7 para anillos focus-visible (3:1 ambos temas;
      --hero-focus al 45% solo llega a 1.7-1.9:1 y no califica, ver CSS). */
  focusRing: "#a855f7",
  // 2026-09-23 FASE 3 FIX diseño H2+H7 (research 2026 Utopia/DTGC single-source:
  // case lower paridad con hero-tokens.css + paradas SSOT 0/42/72/100 — el
  // espejo TS antes usaba UPPER y el btn CSS 0/45/75: un solo lenguaje).
  gradient:
    "linear-gradient(135deg, #4b73ff 0%, #ff66f4 42%, #ff0105 72%, #fe7b02 100%)",
  radius: {
    /** hero-card: modales, tarjetas marketing */
    card: 24,
    /** bento: tarjetas bento, inputs hero */
    bento: 20,
    /** composer: pill del composer */
    composer: 28,
    /** menu: dropdowns, menús */
    menu: 16,
  },
} as const;

export type HeroColorName = keyof Pick<
  typeof HERO_TOKENS,
  "blue" | "magenta" | "red" | "orange" | "focus" | "focusRing" | "gradient"
>;

export type HeroRadiusName = keyof typeof HERO_TOKENS.radius;
